"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CanvaIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.343 13.657A8 8 0 1013.657 2.342 8 8 0 002.343 13.657zM11.17 9.39a.4.4 0 01.11.21.56.56 0 01-.08.4l-.08.16a4.48 4.48 0 01-1.36 1.44c-.4.32-1.12.64-2 .64a3.2 3.2 0 01-1.84-.64c-.48-.4-.88-1.04-1.12-1.84a5.44 5.44 0 012.24-5.6c.4-.24.88-.32 1.44-.32.64 0 1.28.24 1.6.8.24.4.24 1.04 0 1.44-.32.4-.56.48-.8.4A.4.4 0 019.12 6c.32-.48.24-.8 0-1.12a.72.72 0 00-.56-.32c-.48 0-.88.32-1.28.88-.8.96-1.36 2.72-1.04 4.08.24.8.8 1.68 1.84 1.68.32 0 .72-.08 1.04-.24.72-.4.96-.64 1.36-1.2l.16-.32a.32.32 0 01.32-.16.4.4 0 01.21.11z",
    clipRule: "evenodd"
  })))
});
CanvaIcon.displayName = 'CanvaIcon';
var _default = exports.default = CanvaIcon;